import { type RootChartConfigObject, Utils, convertTa } from '../charts-lib'

export function getInitChartConfig(initialConfig: RootChartConfigObject, initialTA = FinvizSettings.TA) {
  const config: RootChartConfigObject = JSON.parse(JSON.stringify(initialConfig))

  config.scrollable = false
  if (FinvizSettings.hasUserPremium) {
    config.scrollable = config.editable || !Utils.isMobile()
  }

  if (initialTA) {
    const COTs = FinvizSettings.COTs
    convertTa.mergeChartAndTAConfig(config, initialTA, COTs ? { COTs } : undefined)
  }

  return config
}
